import { render, staticRenderFns } from "./FeatureTag.vue?vue&type=template&id=10edadf0&scoped=true"
var script = {}
import style0 from "./FeatureTag.vue?vue&type=style&index=0&id=10edadf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10edadf0",
  null
  
)

export default component.exports